import { QuickPassPublicSharePagePayload } from '../../_types/quickpass-share-page'

/**
 * Realistic but entirely fictional pass data for the public demo at
 * `/me/demo`. Lets anyone see exactly what a renter's shared QuickPass looks
 * like — no account, no token, no backend call. Timestamps are computed
 * relative to load time so the demo never looks stale (e.g. a future move-in
 * date, a believable "member since").
 */
const DAY_IN_MS = 24 * 60 * 60 * 1000
const loadTime = Date.now()

const DEMO_SHARE_PAYLOAD: QuickPassPublicSharePagePayload = {
  slug: 'demo',
  displayName: 'Jordan Avery',
  firstName: 'Jordan',
  city: 'Toronto',
  province: 'ON',
  headline: 'Tidy, long-term renter looking for a bright 1-bed downtown',
  customMessage:
    "Hi! I'm a low-drama, long-term renter who treats a place like my own. Happy to share references and hop on a quick call any time.",
  authProviders: ['google'],
  contact: {
    email: 'jordan.avery@example.com',
    phone: '(416) 555-0147',
  },
  preferences: {
    cities: ['Toronto', 'Mississauga'],
    priceMin: 1800,
    priceMax: 2400,
    bedroomCounts: [1, 2],
    bathroomCounts: [1],
    propertyTypes: ['apartment', 'condo'],
    dwellingScope: 'unit',
    preferredMoveInDate: loadTime + 75 * DAY_IN_MS,
    monthlyTakeHomeIncome: null,
  },
  aboutMeParagraphs: {
    aboutMe:
      "I'm a product designer at a small studio and work mostly from home. I've rented the same apartment for four years and I'm only moving because the building is going condo. I'm the neighbour who waters your plants and brings in your parcels.",
    whyGoodFit:
      "Stable income, non-smoker, and glowing references from my last two landlords who'll happily vouch that I pay on time and look after a place. I'm in it for the long haul — somewhere I can settle for years.",
    additionalNotes:
      'I have one well-behaved senior cat — indoor-only and litter-trained. Happy to provide a pet reference and a slightly higher deposit if it helps.',
  },
  savedCount: 14,
  verifications: [
    {
      type: 'identity',
      provider: 'didit',
      displayValue: 'Real, government-verified identity',
      verifiedAt: loadTime - 40 * DAY_IN_MS,
    },
    {
      type: 'income',
      provider: 'plaid',
      displayValue: 'Steady, recurring income',
      verifiedAt: loadTime - 38 * DAY_IN_MS,
    },
    {
      type: 'funds',
      provider: 'plaid',
      displayValue: 'Savings confirmed on hand',
      verifiedAt: loadTime - 38 * DAY_IN_MS,
    },
  ],
  memberSinceTimestamp: loadTime - 480 * DAY_IN_MS,
}

export { DEMO_SHARE_PAYLOAD }
